import { render, staticRenderFns } from "./ViStudentFreeSchoolSummary.vue?vue&type=template&id=852514ca"
import script from "./ViStudentFreeSchoolSummary.vue?vue&type=script&lang=js"
export * from "./ViStudentFreeSchoolSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports